import React, { useCallback, useEffect, useState } from "react";
import Layout from "./Shared/Layout";
import { useNavigate } from "react-router-dom";
import { useWishlist } from "../context/wishlistContext";
import { API_URL } from "../_services/apiUrl";
import { get } from "../_services/apiService";
import { toast } from "react-toastify";

const imageurl = process.env.REACT_APP_IMAGE_BASE_URL

const Wishlist = () => {
    const loginId = localStorage.getItem("loginId");
    const [wishListData, setWishListData] = useState([]);
    const navigate = useNavigate();
    const { removeFromWishlist } = useWishlist();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const GetWishProductByLoginId = useCallback(async () => {
        if (loginId) {
            setLoading(true);
            try {
                const response = await get(`${API_URL?.GetWishProductByLoginId}?pLoginId=${loginId}`);

                // Check if the response is successful
                if (response.isSuccess === 200) {
                    const newData = response.data;
                    setWishListData((prevData) => {
                        if (prevData.length !== newData.length) {
                            return newData;
                        }
                        return prevData;
                    });
                } else {
                    setError('Your wishlist is empty! Start exploring and add your favorite products here.');
                }
            } catch (error) {
                setError('Your wishlist is empty! Start exploring and add your favorite products here.');
            } finally {
                setLoading(false);
            }
        }
    }, [loginId]);

    useEffect(() => {
        GetWishProductByLoginId();
    }, [GetWishProductByLoginId]);

    const onProductDetail = (item) => {
        if (!item) {
            return;
        }

        localStorage.removeItem('sizeTypeName');
        localStorage.removeItem('colorTypeName');
        localStorage.removeItem('skuId');
        localStorage.removeItem('colorId');

        localStorage.setItem('productId', item?.productId);
        localStorage.setItem('productCategoryId', item?.productCategoryId);
        localStorage.setItem('productSubCategoryId', item?.productSubCategoryId);

        const categoryName = item?.categoryName?.replace(/\s+/g, '_') || '';
        const subCategoryName = item?.productSubCategoryName?.replace(/\s+/g, '_') || '';
        const productName = item?.productName?.replace(/\s+/g, '_') || '';

        navigate(`/${categoryName}/${subCategoryName}/${productName}/${item?.productId}`);
    }

    const removewishProductByLoginProductId = async (item) => {
        const isConfirmed = window.confirm("Are you sure you want to delete this item?");
        if (!isConfirmed) {
            return;
        }
        try {
            await removeFromWishlist(item);
            GetWishProductByLoginId();
        } catch (error) {
        }
    }

    const onBuyNow = (item) => {
        if (!item) {
            return;
        }

        localStorage.setItem('SJproductId', item?.productId);
        localStorage.setItem('SJproductCategoryId', item?.productCategoryId);
        localStorage.setItem('SJproductSubCategoryId', item?.productSubCategoryId);

        const categoryName = item?.categoryName?.replace(/\s+/g, '_') || '';
        const subCategoryName = item?.productSubCategoryName?.replace(/\s+/g, '_') || '';
        const productName = item?.productName?.replace(/\s+/g, '_') || '';

        navigate(`/${categoryName}/${subCategoryName}/${productName}/${item?.productId}`);
    }

    if (loading) return <div className="loading_content"><img src="./images/loading.gif" alt="" /></div>;

    return (
        <Layout>
            <section className="d-flex justify-content-center layout_main">
                <div className="container col-xl-8 col-lg-9 col-md-10 col-12">
                    <div className="page-header mb-3">
                        <h1>Wishlist</h1>
                    </div>
                    <div className="row justify-content-center">
                        <div className="">
                            <div className="all_page_heading">
                                {wishListData.length > 0 ?
                                    <div className="product_order_data_wrapper cart-detail d-flex my-4 wishlist_content p-2">
                                        <div className="">
                                            {wishListData?.map((item, j) => (
                                                <React.Fragment key={j}>
                                                    <div className="product_order_content row p-lg-3 " >
                                                        <div className="product_order__image col-sm-2 col-12">
                                                            {item?.productImageDtos && item?.productImageDtos?.length > 0 ? (

                                                                item.productImageDtos.some(image => image.isHeader) ? (
                                                                    item.productImageDtos.map((image, j) => (
                                                                        image.isHeader ? (
                                                                            <img
                                                                                className="w-100"
                                                                                onClick={() => onProductDetail(item)}
                                                                                style={{ cursor: 'pointer' }}
                                                                                key={j}
                                                                                src={`${imageurl}${image.imgPath}`}
                                                                                alt={image.imgPath ? `Product Image ${j + 1}` : 'Product image unavailable'}
                                                                            />
                                                                        ) : null
                                                                    ))
                                                                ) : (
                                                                    <img
                                                                        className="w-100"
                                                                        onClick={() => onProductDetail(item)}
                                                                        style={{ cursor: 'pointer' }}
                                                                        key={j}
                                                                        src={item.productImageDtos[0]?.imgPath ? `${imageurl}${item.productImageDtos[0]?.imgPath}` : './images/defaultImage.png'}
                                                                        alt={item.imgPath ? `Product Image ${j + 1}` : 'Product image unavailable'}
                                                                    />
                                                                )
                                                            ) : (
                                                                <img
                                                                    className="w-100"
                                                                    onClick={() => onProductDetail(item)}
                                                                    style={{ cursor: 'pointer' }}
                                                                    key={j}
                                                                    src='./images/defaultImage.png'
                                                                    alt={item.imgPath ? `Product Image ${j + 1}` : 'Product image unavailable'}
                                                                />
                                                            )}
                                                        </div>
                                                        <div className="product_order_name col-sm-7 col-12">
                                                            <h5 className="product_name curser-pointer" style={{ textTransform: 'capitalize' }} onClick={() => onProductDetail(item)}>{item?.displayName}</h5>
                                                            <p className="mt-1 mb-0 display_desc_cart"
                                                                dangerouslySetInnerHTML={{
                                                                    __html: item?.displayDesc?.length > 80 ? `${item.displayDesc.substring(0, 80)}...` : item?.displayDesc
                                                                }}
                                                                title={item?.displayDesc}
                                                            />
                                                            <div className="wishlist_price">
                                                                <p style={{ color: '#8e183c', fontWeight: '500' }}>₹{item?.salePrice} <del>₹{item?.mrp}</del></p>
                                                            </div>
                                                        </div>
                                                        <div className="col-sm-3">
                                                            <div className="wishlist_buttons p-0 d-flex justify-content-sm-end align-items-end">
                                                                <button className='buy_now_icon web_buttons' onClick={() => onBuyNow(item)}>
                                                                    <svg
                                                                        id="Layer_1"
                                                                        xmlns="http://www.w3.org/2000/svg"
                                                                        xmlnsXlink="http://www.w3.org/1999/xlink"
                                                                        xmlnssvgjs="http://svgjs.dev/svgjs"
                                                                        viewBox="0 0 24 24"
                                                                        width="25"
                                                                        height="25"
                                                                    >
                                                                        <g transform="matrix(1,0,0,1,0,0)" width="100%" height="100%">
                                                                            <path
                                                                                d="m20 24h-16c-2.2 0-4-1.8-4-4v-16c0-2.2 1.8-4 4-4h16c2.2 0 4 1.8 4 4v16c0 2.2-1.8 4-4 4z"
                                                                                fill="#ffffff"
                                                                                fillOpacity="0"
                                                                                stroke="none"
                                                                            />
                                                                            <path
                                                                                d="m21 16h-16c-.6 0-1-.4-1-1s.4-1 1-1h13c.4 0 .8-.2.9-.6l3-7c.1-.3.1-.7-.1-.9-.2-.3-.5-.5-.8-.5h-14.6l-.4-2.2c-.1-.5-.5-.8-1-.8h-2c-.6 0-1 .4-1 1s.4 1 1 1h1.2l1.6 8h-.8c-1.7 0-3 1.3-3 3 0 1.4.9 2.5 2.2 2.9-.1.3-.2.7-.2 1.1 0 1.7 1.3 3 3 3s3-1.3 3-3c0-.4-.1-.7-.2-1h4.4c-.1.3-.2.6-.2 1 0 1.7 1.3 3 3 3s3-1.3 3-3c0-.4-.1-.7-.2-1h1.2c.6 0 1-.4 1-1s-.4-1-1-1zm-14.2-9h12.7l-2.1 5h-9.6zm1.2 12c0 .6-.4 1-1 1s-1-.4-1-1 .4-1 1-1 1 .4 1 1zm10 0c0 .6-.4 1-1 1s-1-.4-1-1 .4-1 1-1 1 .4 1 1z"
                                                                                fill="#ffffff"
                                                                                stroke="none"
                                                                            />
                                                                        </g>
                                                                    </svg>
                                                                </button>
                                                                <button className='delete_wishlist_btn web_buttons' onClick={() => removewishProductByLoginProductId(item)}>
                                                                    <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="20" height="20" viewBox="0 0 24 24">
                                                                        <path d="M 10 2 L 9 3 L 4 3 L 4 5 L 5 5 L 5 20 C 5 20.522222 5.1913289 21.05461 5.5683594 21.431641 C 5.9453899 21.808671 6.4777778 22 7 22 L 17 22 C 17.522222 22 18.05461 21.808671 18.431641 21.431641 C 18.808671 21.05461 19 20.522222 19 20 L 19 5 L 20 5 L 20 3 L 15 3 L 14 2 L 10 2 z M 7 5 L 17 5 L 17 20 L 7 20 L 7 5 z M 9 7 L 9 18 L 11 18 L 11 7 L 9 7 z M 13 7 L 13 18 L 15 18 L 15 7 L 13 7 z" fill="#ffffff"></path>
                                                                    </svg>
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="horizantal_line"></div>
                                                </React.Fragment>
                                            ))}
                                        </div>
                                    </div>
                                    :
                                    <div className="mt-4">
                                        <p className="text-white">{error}</p>
                                    </div>
                                }
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </Layout>
    )
}

export default Wishlist;